/*
  Añadir al carrito sin salir de la página.

  Por defecto, un <form action="/cart/add"> recarga y te lleva a /cart, que
  saca al cliente de la ficha justo cuando está comprando. Aquí se intercepta
  el envío, se manda por detrás y solo se actualiza el número del icono.

  Cubre los tres formularios de la tienda: el de la ficha (un producto), el de
  «Completa tu rutina» (dos sueltos) y el del pack (una sola línea).
*/
(function () {
  'use strict';

  var TEXTO_OK = 'Añadido ✓';
  var MS_AVISO = 1800;

  function esFormularioDeCarrito(form) {
    var accion = form.getAttribute('action') || '';
    return accion.indexOf('/cart/add') !== -1;
  }

  /* El número del icono: Dawn solo pinta la burbuja si el carrito NO está
     vacío, así que en la primera compra hay que crearla. */
  function pintarContador(total) {
    var enlace = document.querySelector('#cart-icon-bubble, a[href$="/cart"]');
    if (!enlace) return;

    var burbuja = enlace.querySelector('.cart-count-bubble');
    if (!burbuja) {
      burbuja = document.createElement('div');
      burbuja.className = 'cart-count-bubble';
      enlace.appendChild(burbuja);
    }
    burbuja.innerHTML =
      '<span aria-hidden="true">' + (total < 100 ? total : '') + '</span>' +
      '<span class="visually-hidden">' + total + ' artículos en el carrito</span>';
  }

  function avisarEnBoton(boton) {
    if (!boton) return;
    var original = boton.dataset.textoOriginal || boton.innerHTML;
    boton.dataset.textoOriginal = original;
    boton.innerHTML = TEXTO_OK;
    boton.disabled = true;
    setTimeout(function () {
      boton.innerHTML = original;
      boton.disabled = false;
    }, MS_AVISO);
  }

  function mostrarError(boton, mensaje) {
    if (!boton) return;
    var original = boton.dataset.textoOriginal || boton.innerHTML;
    boton.dataset.textoOriginal = original;
    boton.innerHTML = mensaje || 'No se pudo añadir';
    setTimeout(function () { boton.innerHTML = original; }, 2600);
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!(form instanceof HTMLFormElement) || !esFormularioDeCarrito(form)) return;

    evento.preventDefault();
    var boton = form.querySelector('button[type="submit"], button:not([type])');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (datos) {
          if (!r.ok) throw datos;
          return datos;
        });
      })
      .then(function (anadido) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (carrito) { return { carrito: carrito, anadido: anadido }; });
      })
      .then(function (resultado) {
        var carrito = resultado.carrito;
        pintarContador(carrito.item_count);
        avisarEnBoton(boton);
        /* En la propia página del carrito hay que repintar la lista para que
           se vea lo que se acaba de añadir. */
        if (form.dataset.recargar === 'true') {
          setTimeout(function () { window.location.reload(); }, 600);
        }
        /* Por si el tema tiene el cajón lateral o alguna app escuchando.
           Se incluye lo que ACABA de añadirse (`anadido`), porque es lo único
           que sabe de verdad qué productos y a qué precio han entrado: el
           formulario del pack manda varias líneas y el de la ficha una sola.
           La medición cuelga de aquí (snippets/reset-datalayer.liquid). */
        document.dispatchEvent(new CustomEvent('reset:carrito-actualizado', {
          detail: { carrito: carrito, anadido: resultado.anadido }
        }));
      })
      .catch(function (error) {
        /* Lo más común: se acabaron las existencias. */
        mostrarError(boton, (error && error.description) ? 'Sin stock' : null);
        console.warn('No se pudo añadir al carrito:', error);
      });
  });
})();
